import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as templateActions from 'modules/templateAttach';

class ExamAttachEditModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    }
  }

  editTemplate = async () => {
    this.setState({ loading: true });

    const { templateInfo: { attachInfoNo }, TemplateActions } = this.props;

    try {
      const params = {
        attachInfoNo: attachInfoNo
      };

      await TemplateActions.updateAttach(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { templateInfo: { attachInfoNo, isPublic, attachSubject }, handleOnToggleModal } = this.props;
    const { editTemplate } = this;
    const { loading } = this.state;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={'modal-admin tiny common-content'}
        closeIcon
        onToggleModal={handleOnToggleModal}
        visible
        header={
          <div>{defineMessages(formatMessage({ id: 'ExamAttachInTableMenu_1', defaultMessage: '첨부파일 수정' }))}</div>
        }
        buttons={
          <div className={'inline-block'}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleModal}>
              {defineMessages(formatMessage({ id: 'ModalExamEdit_3', defaultMessage: '취 소' }))}
            </Btn>
            <Btn className={'gray-button'} loading={loading} disabled={loading} onClick={editTemplate}>
              {defineMessages(formatMessage({ id: 'ModalExamEdit_2', defaultMessage: '수 정' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={loading}
          size="small"
          content={defineMessages(formatMessage({ id: 'UserEdit_1', defaultMessage: '처리중...' }))}
        />

        <div className={'message-header'}>
          {isPublic
            ? defineMessages(
              formatMessage({
                id: 'ExamAttachEdit_1',
                defaultMessage: '다음 첨부파일을 비공개로 변경합니까?'
              }))
            : defineMessages(
              formatMessage({
                id: 'ExamAttachEdit_2',
                defaultMessage: '다음 첨부파일을 공개로 변경합니까?'
              })
            )}
        </div>
        <Message className={'template-detail-box'}>
          <div className={'template-detail'}>
            <List bulleted className={'template-detail-list'}>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>No</div>
                {attachInfoNo}
              </List.Item>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>
                  {defineMessages(formatMessage({ id: 'ExamAttachDelete_3', defaultMessage: '제목' }))}
                </div>
                {attachSubject}
              </List.Item>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEdit_32', defaultMessage: '공개 여부' }))}
                </div>
                {isPublic
                  ? defineMessages(formatMessage({ id: 'ExamTemplateEdit_34', defaultMessage: '공개' }))
                  : defineMessages(formatMessage({ id: 'ExamTemplateEdit_33', defaultMessage: '비공개' }))}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(null, mapDispatchToProps)(injectIntl(ExamAttachEditModal));


// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachEditModal.js